

import {CommunicationCategory} from '../../../../api/communication';

export type CategoryTab = CommunicationCategory | 'all' | 'separator';

export const categories : CategoryTab[] = [ 'all', 'read', 'unread' ];
